import styled from 'styled-components';

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end; // space-between;
  align-items: center;
  background-color: #fff;
  // position: fixed;
  bottom: 0;
  right: 0;
  width: 700px;
	// visibility: hidden;

  button {
    font-weight: 600;
    border-radius: 7px;
    padding: 5px 10px;
    margin: 0px 10px;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 1px solid var(--red-razio);
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;